import React, { Component } from 'react';
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react';
import { Redirect } from 'react-router-dom';

const mapStyles = {
  width: '100%',
  height: '100%',
  zIndex: 4
};

class MapContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: "",
      stores: [{lat: 42.683103, lng: -71.349918,
          title:"Green Thumb Growers", path: "gt"},
        {lat: 42.38, lng: -71.2,
          title:"Najarian Music", path: "nj"},
        {lat: 41.98, lng: -70.9,
          title:"Pot Palace", path: "pp"}]
    }
  }

  componentDidMount () {
    this.setState({
      redirect: ""
    })
  }

  redirectToStore = (path) => {
    let fullPath = "/store/"+path
    this.setState({
      redirect: fullPath
    })
  }

  displayMarkers = () => {
    return this.state.stores.map((store, index) => {
      return (
        <Marker key={index} id={index} position={{
           lat: store.lat,
           lng: store.lng
         }}
         title={store.title}
         onClick={() => this.redirectToStore(store.path)}
         icon={{
            url: "/images/icons8-cannabis-96.png",
            anchor: new this.props.google.maps.Point(32,32),
            scaledSize: new this.props.google.maps.Size(64,64)
          }}
        />
      )
    })
  }

  render() {
    if (this.state.redirect === "") {
      return (
          <Map
            google={this.props.google}
            zoom={8}
            style={mapStyles}
            initialCenter={{ lat: 42.369, lng: -71.181}}
          >
            {this.displayMarkers()}
          </Map>
      );
    } else {
      return(<Redirect to={this.state.redirect} />)
    }
  }
}


export default GoogleApiWrapper({
  apiKey: 'AIzaSyCz0A1iLL2N_sDmlqLoDI6Yk-jO-AwgWFc'
})(MapContainer);
